
 export const emojiCategories = {
    "😀": [
      "😀",
      "😁",
      "😂",
      "🤣",
      "😃",
      "😄",
      "😅",
      "😆",
      "😉",
      "😊",
      "😋",
      "😎",
      "😍",
      "😘",
      "😗",
      "😙",
      "😚",
      "🙂",
      "🤗",
      "🤩",
      "🥳",
      "😏",
      "😒",
      "😞",
      "😔",
      "😟",
      "😢",
      "😭",
      "😤",
      "😠",
      "😡",
      "🤬",
      "🤯",
      "😳",
      "🥺",
      "😨",
      "😰",
      "😥",
      "🤥",
      "🤫",
      "🤭",
      "🫢",
      "🫡",
      "🤔",
      "🙄",
      "😬",
      "😴",
      "🥱",
      "🤤",
      "🤢",
    ],

    "🖐️": [
      "👋",
      "🤚",
      "🖐️",
      "✋",
      "🖖",
      "👌",
      "🤌",
      "🤏",
      "✌️",
      "🤞",
      "🤟",
      "🤘",
      "🤙",
      "👈",
      "👉",
      "👆",
      "🖕",
      "👇",
      "☝️",
      "👍",
      "👎",
      "✊",
      "👊",
      "🤛",
      "🤜",
      "👏",
      "🙌",
      "👐",
      "🤲",
      "🙏",
    ],

    "🍕": [
      "🍏",
      "🍎",
      "🍐",
      "🍊",
      "🍋",
      "🍌",
      "🍉",
      "🍇",
      "🍓",
      "🫐",
      "🥭",
      "🍍",
      "🥥",
      "🥑",
      "🥦",
      "🥒",
      "🌽",
      "🍠",
      "🥔",
      "🥕",
      "🌰",
      "🥜",
      "🍞",
      "🥐",
      "🥖",
      "🫓",
      "🥞",
      "🧇",
      "🍗",
      "🍖",
      "🍕",
      "🌭",
      "🍔",
      "🍟",
      "🍜",
      "🍣",
      "🍩",
      "🍪",
      "🎂",
      "🍫",
    ],

    "🎉": [
      "🎃",
      "🎄",
      "🎆",
      "🎇",
      "🎈",
      "🎉",
      "🎊",
      "🎁",
      "🎀",
      "🎤",
      "🎧",
      "🎼",
      "🎷",
      "🎸",
      "🎻",
      "🥁",
      "🎮",
      "🕹️",
      "🎰",
      "🎳",
      "⛳",
      "🥊",
      "🏀",
      "⚽",
      "🏈",
      "⚾",
      "🥎",
      "🎾",
      "🎱",
      "🏆",
    ],

    "🚗": [
      "🚗",
      "🚕",
      "🚙",
      "🚌",
      "🚎",
      "🏎️",
      "🚓",
      "🚑",
      "🚒",
      "🚜",
      "✈️",
      "🚀",
      "🛸",
      "⛵",
      "🛳️",
      "🗺️",
      "🏝️",
      "🏞️",
      "🏰",
      "🗽",
    ],

    "💡": [
      "❤️",
      "💙",
      "💚",
      "💛",
      "💜",
      "🖤",
      "🤍",
      "🤎",
      "💔",
      "❣️",
      "💥",
      "💢",
      "💦",
      "💨",
      "🔥",
      "⭐",
      "🌟",
      "✨",
      "⚡",
      "💫",
      "💬",
      "🗨️",
      "🗯️",
      "💭",
      "🕒",
      "⏳",
      "🕰️",
      "🛑",
      "🚸",
      "⚠️",
    ],

    "📞": [
      "📞",
      "☎️",
      "📱",
      "📲",
      "🖥️",
      "💻",
      "⌨️",
      "🖱️",
      "🖲️",
      "📟",
      "📠",
      "📺",
      "📻",
      "🎙️",
      "📡",
      "📩",
      "✉️",
      "📧",
      "📨",
      "📬",
    ],

    "💼": [
      "💼",
      "📊",
      "📈",
      "📉",
      "📅",
      "📆",
      "📝",
      "🖊️",
      "🖋️",
      "✒️",
      "📎",
      "📏",
      "📐",
      "📂",
      "📌",
      "🔖",
      "🗄️",
      "🏢",
      "🏦",
      "🏛️",
    ],
  };


  export const countryCodes = [
    { code: "91", label: "🇮🇳 India (+91)" },
    { code: "1", label: "🇺🇸 USA (+1)" },
    { code: "44", label: "🇬🇧 UK (+44)" },
    { code: "61", label: "🇦🇺 Australia (+61)" },
    { code: "81", label: "🇯🇵 Japan (+81)" },
    { code: "971", label: "🇦🇪 UAE (+971)" },
    { code: "49", label: "🇩🇪 Germany (+49)" },
    { code: "33", label: "🇫🇷 France (+33)" },
    { code: "39", label: "🇮🇹 Italy (+39)" },
    { code: "34", label: "🇪🇸 Spain (+34)" },
    { code: "7", label: "🇷🇺 Russia (+7)" },
    { code: "86", label: "🇨🇳 China (+86)" },
    { code: "55", label: "🇧🇷 Brazil (+55)" },
    { code: "27", label: "🇿🇦 South Africa (+27)" },
    { code: "62", label: "🇮🇩 Indonesia (+62)" },
    { code: "82", label: "🇰🇷 South Korea (+82)" },
    { code: "90", label: "🇹🇷 Turkey (+90)" },
    { code: "52", label: "🇲🇽 Mexico (+52)" },
    { code: "880", label: "🇧🇩 Bangladesh (+880)" },
    { code: "92", label: "🇵🇰 Pakistan (+92)" },
    { code: "66", label: "🇹🇭 Thailand (+66)" },
    { code: "20", label: "🇪🇬 Egypt (+20)" },
    { code: "98", label: "🇮🇷 Iran (+98)" },
    { code: "31", label: "🇳🇱 Netherlands (+31)" },
    { code: "46", label: "🇸🇪 Sweden (+46)" },
    { code: "47", label: "🇳🇴 Norway (+47)" },
    { code: "48", label: "🇵🇱 Poland (+48)" },
    { code: "32", label: "🇧🇪 Belgium (+32)" },
    { code: "30", label: "🇬🇷 Greece (+30)" },
    { code: "43", label: "🇦🇹 Austria (+43)" },
    { code: "351", label: "🇵🇹 Portugal (+351)" },
    { code: "64", label: "🇳🇿 New Zealand (+64)" },
    { code: "63", label: "🇵🇭 Philippines (+63)" },
    { code: "41", label: "🇨🇭 Switzerland (+41)" },
    { code: "45", label: "🇩🇰 Denmark (+45)" },
    { code: "351", label: "🇵🇹 Portugal (+351)" },
    { code: "56", label: "🇨🇱 Chile (+56)" },
    { code: "93", label: "🇦🇫 Afghanistan (+93)" },
    { code: "94", label: "🇱🇰 Sri Lanka (+94)" },
    { code: "233", label: "🇬🇭 Ghana (+233)" },
    { code: "234", label: "🇳🇬 Nigeria (+234)" },
    { code: "36", label: "🇭🇺 Hungary (+36)" },
    { code: "212", label: "🇲🇦 Morocco (+212)" },
    { code: "213", label: "🇩🇿 Algeria (+213)" },
    { code: "216", label: "🇹🇳 Tunisia (+216)" },
    { code: "250", label: "🇷🇼 Rwanda (+250)" },
    { code: "254", label: "🇰🇪 Kenya (+254)" },
    { code: "256", label: "🇺🇬 Uganda (+256)" },
    { code: "62", label: "🇮🇩 Indonesia (+62)" },
  ];